
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trade-in",
      function () {
        return require("private-next-pages/trade-in/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trade-in"])
      });
    }
  